<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>变卖清理单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>清理单信息</span>
        </div>
        <el-form :model="assetFiscalClearVoucher" :rules="rulesInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">机构信息</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="srcComName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="assetFiscalClearVoucher.retailerBizUnitName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectSrcComName"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title">
                            <el-input type="text" v-model="assetFiscalClearVoucher.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>说明</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="memo">
                            <el-input type="textarea" :rows="2" placeholder="请输入说明" v-model="assetFiscalClearVoucher.memo"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!--14636 资产清理审核时，去掉自动清除的操作；-->
            <div class="simple-form" v-if="autoApplyAndAudit && false">
                <div class="form-group center">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <div class="inline-block mr20">
                            <el-form-item>
                                <el-checkbox v-model="autoClearFlag">自动清除</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>资产信息</span>

            <div class="input-tip error font12">提示:一次清理数据最多500条</div>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-button type="primary" @click="showDeviceListDlg()">
                    <span>通用选择</span>
                </el-button>
            </div>
            <div class="right">
                <span>已选择({{ (assetFiscalClearVoucher.itemList || []).length }})</span>
            </div>
        </div>
        <div class="table-layout">
            <div class="table-layout" style="width: 100%;overflow-x: auto">
                <el-form :model="assetFiscalClearVoucher" ref="deviceInfo">
                    <table class="custom-tbl error-prompt">
                        <thead class="head">
                        <tr class="row">
                            <th width="200" style="text-align: left;">部门全称</th>
                            <th width="300" style="text-align: left;">资产描述全称</th>
                            <th width="300" style="text-align: left;">名称</th>
                            <th width="240" style="text-align: left;">型号</th>
                            <th width="240" style="text-align: left;">规格</th>
                            <th width="270">系统编号</th>
                            <th width="260">商品标识码</th>
                            <th width="240" style="text-align: left;">资产分类</th>
                            <th width="100" style="text-align: left;">维保分组</th>
                            <th width="120" style="text-align: left;">资产品牌</th>
                            <th width="90" style="text-align: center;">入账方式</th>
                            <th width="100" style="text-align: center;">是否财务在账</th>
                            <th width="100" style="text-align: right;">额外收入(元)</th>
                            <th width="100" style="text-align: right;">额外费用(元)</th>
                            <th width="160" style="text-align: left;">批次号</th>
                            <th width="160" style="text-align: left;">资产编号</th>
                            <th width="100" style="text-align: right;">清理数量</th>
                            <th width="80">单位</th>
                            <th width="120" style="text-align: left;">处理说明</th>
                            <th width="100" style="text-align: left;">管理方式</th>
                            <th width="120">操作</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row" v-for="(deviceItem, index) in assetFiscalClearVoucher.itemList">
                            <td style="text-align: left;">{{ deviceItem.retailerComFullName }}</td>
                            <td style="text-align: left;">{{ deviceItem.title }}</td>
                            <td style="text-align: left;">{{ deviceItem.name }}</td>
                            <td style="text-align: left;">{{ deviceItem.model }}</td>
                            <td style="text-align: left;">{{ deviceItem.fixedSpec }}</td>
                            <td>{{ deviceItem.tmpNo }}</td>
                            <td>{{ deviceItem.vendorUkno }}</td>
                            <td style="text-align: left;">{{ deviceItem.innerDevcCatFullName }}</td>
                            <td style="text-align: left;">{{ deviceItem.devcGroupFullName }}</td>
                            <td style="text-align: left;">{{ deviceItem.innerDevcBrandName }}</td>
                            <td style="text-align: center;">{{ acctEnterWayMap[deviceItem.acctEnterWay] }}</td>
                            <td style="text-align: center;">{{ deviceItem.fiscalAcctFlag == 1 ? '是' : '否' }}</td>
                            <td style="text-align: right;">
                                <el-form-item :prop="'itemList.' + index + '.extraIncome'" :rules="{validator: inputExtraIncome, trigger: 'blur'}">
                                    <el-input class="input-content-right" type="text" v-model="deviceItem.extraIncome"></el-input>
                                </el-form-item>
                            </td>
                            <td style="text-align: right;">
                                <el-form-item :prop="'itemList.' + index + '.extraCostFee'" :rules="{validator: inputExtraCostFee, trigger: 'blur'}">
                                    <el-input class="input-content-right" type="text" v-model="deviceItem.extraCostFee"></el-input>
                                </el-form-item>
                            </td>
                            <td style="text-align: left;">{{ deviceItem.batchNo }}</td>
                            <td style="text-align: left;">{{ deviceItem.devcInnerCode }}</td>
                            <td style="text-align: right;">{{ deviceItem.quantity }}</td>
                            <!-- 全部清理，数量不可修改 2021-07-19 -->
                            <!--                            <td style="text-align: right;" v-if="deviceItem.assetType == commonDevcVal">{{deviceItem.quantity}}</td>-->
                            <!--                            <td style="text-align: right;" v-else>-->
                            <!--                                &lt;!&ndash; 全部清理，数量不可修改 2021-07-19 ==> 2022-01-27又改为可修改数量 &ndash;&gt;-->
                            <!--                                <el-form-item :prop="'itemList.' + index + '.quantity'" :rules="{validator: quantityChange, trigger: 'blur'}">-->
                            <!--                                    <el-input class="text-right" type="number" min="1" v-model="deviceItem.quantity" @change="changeQuantity(deviceItem)"></el-input>-->
                            <!--                                </el-form-item>-->
                            <!--                            </td>-->
                            <td>{{ deviceItem.theUnit }}</td>
                            <td style="text-align: left;">
                                <el-input class="textarea-value" type="textarea" v-model="deviceItem.handleDesc"></el-input>
                            </td>
                            <td>{{ assetTypeMap[deviceItem.assetType] }}</td>
                            <td style="text-align: left;">
                                <a class="swb-btn-link" @click="deleteDevice(index)">移除</a>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot class="foot">
                        <tr v-if="assetFiscalClearVoucher.itemList.length <= 0">
                            <td colspan="15" style="text-align: center; line-height: 40px;">
                                <span class="font-gray3">暂无数据</span>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </el-form>
            </div>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveAssetFiscalClearVoucher">保存</button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {showDevcSelectDlg} from '../devc/selectDlg'
    import {isSysRescFrozenIsAllowed, syncSetBreadcrumb} from '../index'
    import {getMerchantBizParam} from '../asset/assetMain'

    import userApi from '../../api/user'
    import assetFiscalApi from '../../api/assetFiscal'
    //
    import SwbAssetFiscalClearVoucherList from './AssetFiscalClearVoucherList'
    import SwbAssetAdvancedView from '../asset/AssetAdvancedView';

    Vue.regist(SwbAssetFiscalClearVoucherList);
    Vue.regist(SwbAssetAdvancedView);

    export default {
        name: 'swb-asset-fiscal-clear-voucher-save',
        path: '/asset/fiscal/clear/voucher/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: true,
        desc: '变卖清理单 - 制作',
        data: function () {
            let validateTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('标题不能为空！'));
                } else {
                    callback();
                }
            };
            return {
                assetFiscalClearVoucher: {
                    itemList: []
                },
                voucherId: null,
                acctEnterWayMap: {},
                commonDevcVal: getEnumInfoWith('assetType', 'name', 'CommonDevc').value,
                durableDevcVal: getEnumInfoWith('assetType', 'name', 'DurableDevc').value,
                assetTypeMap: getEnumMap("assetType", "value2text"),
                //
                autoApply: false,
                autoAuditPass: false,
                autoClearFlag: false,
                //
                autoApplyAndAudit: false,
                rulesInfo: {
                    title: [{validator: validateTitle, trigger: 'blur'}]
                },
                parentPath: null
            }
        },
        created: function () {
            //
            this.parentPath = this.$route.query.parentPath;
            syncSetBreadcrumb("清理单 - 制作", this.parentPath);
            //
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            //
            this.voucherId = this.$route.query.id || null;
            this.autoApplyAndAudit = this.$route.query.autoApplyAndAudit || null;
            //
            this.getCurrentUserInfo();
        },
        methods: {
            // 额外收入校验
            inputExtraIncome: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 额外费用校验
            inputExtraCostFee: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 清理数量校验
            quantityChange: function (rule, value, callback) {

                if (Utils.isNoB(value)) {
                    callback(new Error("请输入清理数量"));
                } else {
                    if (!Utils.isNaturalStr(value, true)) {
                        callback(new Error("请输入大于0的整数！"));
                    } else {
                        callback();
                    }
                }
            },
            changeQuantity: function (durableItem) {
                let existQuanity = durableItem.existQuanity;
                if (Utils.isNoB(existQuanity)) {
                    existQuanity = 0;
                }
                let quantity = durableItem.quantity;
                //
                if (quantity > existQuanity) {
                    MsgBox.warning(durableItem.title + "清理数量不能超过可清理数量:" + existQuanity);
                }
            },
            //
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        let comInfo = {};
                        comInfo.id = data.scopeEntity.bizUnitId;
                        let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
                        if (isAllowed) {
                            let assetFiscalClearVoucher = self.assetFiscalClearVoucher;
                            assetFiscalClearVoucher.retailerBizUnitId = data.scopeEntity.bizUnitId;
                            assetFiscalClearVoucher.retailerBizUnitName = data.scopeEntity.bizUnitName;
                            self.assetFiscalClearVoucher = Utils.merge({}, assetFiscalClearVoucher);
                        }
                        if (!Utils.isNoB(self.voucherId)) {
                            self.getAssetFiscalClearVoucher();
                        }
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            },
            //
            getAssetFiscalClearVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                assetFiscalApi.getAssetFiscalClearVoucherInfo(postData, function (result) {
                    if (result.type == "info") {
                        let assetFiscalClearVoucher = result.data;
                        //
                        self.assetFiscalClearVoucher = Utils.merge({}, assetFiscalClearVoucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 选择资产
            showDeviceListDlg: function () {
                let self = this;
                let assetFiscalClearVoucher = self.assetFiscalClearVoucher;
                let itemList = assetFiscalClearVoucher.itemList || [];
                let deviceXIds = itemList.pluck("deviceXId") || [];
                if (Utils.isNoB(assetFiscalClearVoucher.retailerBizUnitId)) {
                    MsgBox.warning("请选择机构信息！");
                    return;
                }
                //
                let filter = {};
                filter.retailerComId = assetFiscalClearVoucher.retailerBizUnitId;
                filter.cleared = false;
                filter.sellofFlag = false;
                filter.locked = false;
                filter.fiscalLocked = false;
                let params = {
                    filter: filter,
                    devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "QingLiDlg").name,   // 清理选择
                    initSelectIds: deviceXIds,
                    selectAll: true
                };
                showDevcSelectDlg(params, function (deviceList) {
                    //
                    deviceList = self.makeFiscalClearItems(deviceList);
                    itemList = itemList.concat(deviceList);
                    assetFiscalClearVoucher.itemList = Utils.merge([], itemList);
                    //
                    self.assetFiscalClearVoucher = Utils.merge({}, assetFiscalClearVoucher);
                });
            },

            makeFiscalClearItems: function (deviceItemList) {
                let self = this;
                let itemsList = [];
                if (!Utils.isNoB(deviceItemList)) {
                    deviceItemList.forEach(function (deviceItem) {
                        let item = {
                            retailerComName: deviceItem.retailerComName,
                            retailerComFullName: deviceItem.retailerComFullName,
                            deviceXId: deviceItem.id,
                            assetType: deviceItem.assetType,
                            tmpNo: deviceItem.tmpNo,
                            vendorUkno: deviceItem.vendorUkno,
                            innerDevcBrandId: deviceItem.innerDevcBrandId,
                            innerDevcBrandName: deviceItem.innerDevcBrandName,
                            innerDevcBrandCode: deviceItem.innerDevcBrandCode,
                            title: deviceItem.title,
                            name: deviceItem.name,
                            model: deviceItem.model,
                            fixedSpec: deviceItem.fixedSpec,
                            modelSpec: deviceItem.modelSpec,
                            acctEnterWay: deviceItem.acctEnterWay,
                            orgWorth: deviceItem.orgWorth,
                            netWorth: deviceItem.netWorth,
                            devcGroupFullName: deviceItem.devcGroupFullName,
                            innerDevcCatId: deviceItem.innerDevcCatId,
                            innerDevcCatFullName: deviceItem.innerDevcCatFullName,
                            theUnit: deviceItem.theUnit,
                            batchNo: deviceItem.batchNo,
                            devcInnerCode: deviceItem.innerCode,
                            inStkQuantity: deviceItem.inStkQuantity,
                            inStkAvQuantity: deviceItem.inStkAvQuantity,
                            fiscalQuantity: deviceItem.fiscalQuantity,
                            existQuanity: deviceItem.existQuanity,
                            quantity: Utils.isTrue(self.durableDevcVal == deviceItem.assetType) ? deviceItem.existQuanity : 1,
                            fiscalAcctFlag: deviceItem.fiscalAcctFlag
                        };
                        itemsList.add(item);
                    });
                }
                return itemsList;
            },
            // 移除设备
            deleteDevice: function (index) {
                let itemList = this.assetFiscalClearVoucher.itemList || [];
                for (let i = 0; i < itemList.length; i++) {
                    if (i == index) {
                        itemList.splice(i, 1);
                        break;
                    }
                }
                this.assetFiscalClearVoucher.itemList = Utils.merge([], itemList);
            },
            //返回
            prevStock: function () {
                let self = this;
                self.$router.back(-1);
            },
            // 保存清理单
            saveAssetFiscalClearVoucher: function () {
                if (!Utils.repeatChecker.isValidFor("saveAssetFiscalClearVoucher", 1000)) {
                    return;
                }
                let self = this;
                if (Utils.isTrue(this.autoApplyAndAudit)) {  // 登记自动申请审核
                    this.autoApply = true;
                    this.autoAuditPass = true;
                }
                //
                self.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        let assetFiscalClearVoucher = self.assetFiscalClearVoucher;
                        // 资产
                        let itemList = assetFiscalClearVoucher.itemList || [];
                        //
                        if (itemList.length <= 0) {
                            Toast.show("请选择资产");
                            return;
                        }
                        // 有耐用品的时候进行耐用品相关的校验
                        if (itemList.length > 0) {
                            let validateFailure = false;
                            self.$refs['deviceInfo'].validate(function (valid) {
                                if (valid) {
                                    //
                                    // for(let i = 0; i < itemList.length; i++) {
                                    //     let item = itemList[i];
                                    //     if(Utils.isNoB(item.quantity)) {
                                    //         validateFailure = true;
                                    //         Toast.show("请设置清理数量！");
                                    //         break;
                                    //     } else {
                                    //         let existQuanity = item.existQuanity;
                                    //         if(Utils.isNoB(existQuanity)) {
                                    //             existQuanity = 0;
                                    //         }
                                    //         let quantity = item.quantity;
                                    //         //
                                    //         if(quantity > existQuanity) {
                                    //             validateFailure = true;
                                    //             Toast.show(item.title + "清理数量不能超过可清理数量:" + existQuanity);
                                    //             break;
                                    //         }
                                    //     }
                                    //
                                    // }
                                } else {
                                    validateFailure = true;
                                    Toast.show("请输入批量式资产中相应的数据！");
                                }
                            });
                            if (validateFailure) {
                                return;
                            }
                        }
                        //
                        if (itemList.length > 500) {
                            MsgBox.warning("【资产】支持最大单据级条目为500条！现" + itemList.length + "条！");
                            return;
                        }
                        assetFiscalClearVoucher.autoApply = self.autoApply;
                        assetFiscalClearVoucher.autoAuditPass = self.autoAuditPass;
                        assetFiscalClearVoucher.autoClearFlag = self.autoClearFlag;
                        //
                        let loading = MsgBox.loading();
                        assetFiscalApi.saveAssetFiscalClearVoucher(assetFiscalClearVoucher, function (result) {
                            loading.close();
                            if (result.type == "info") {
                                MsgBox.success("保存成功");
                                // 跳转报废单
                                self.$router.push({
                                    path: self.parentPath,
                                });

                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            selectSrcComName: function () {
                let self = this;
                Vue.$showDialog({
                    title: '零售商机构-选择',
                    width: 750,
                    height: 600,
                    showCloseBtn: true,
                    template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom"  ref="swb_org_tree"></swb-org-tree>',
                    data: {
                        isRadio: true,
                        isCom: false,
                        isSelectThisLevel: true
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                        if (result.type == "info") {
                            let shopRetail = result.data || {};
                            //
                            let assetFiscalClearVoucher = self.assetFiscalClearVoucher || {};
                            assetFiscalClearVoucher.comId = shopRetail.id;
                            assetFiscalClearVoucher.comName = shopRetail.name;
                            assetFiscalClearVoucher.retailerBizUnitId = shopRetail.bizUnitId;
                            assetFiscalClearVoucher.retailerBizUnitName = shopRetail.bizUnitName;
                            //
                            assetFiscalClearVoucher.itemList = [];
                            self.assetFiscalClearVoucher = Utils.merge({}, assetFiscalClearVoucher);
                        } else {
                            return false;
                        }
                    }
                });
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetFiscalClearVoucherSave.vue